import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress page, "Will I Go Bald? Calculate My Odds". Other sites
// still link to it (Ahrefs, 1 Nov 2026), so it goes to the will-i-go-bald
// post rather than the home page. Keep ROUTE_REDIRECTS in
// blog-internal-links.ts the same.
export const Route = createFileRoute("/will-i-go-bald-calculator")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/will-i-go-bald/", location.searchStr), statusCode: 301 });
  },
});
